export default __webpack_public_path__ + "static/media/Adventurer's Pack-Bag.018d0ef4.jpg";